import clsx from 'clsx'

const SIZE_CLASSES = {
  xs: 'h-4 w-4',
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
  lg: 'h-10 w-10',
  xl: 'h-14 w-14',
  '2xl': 'h-20 w-20'
}

function BrandMark({ size = 'md', title, className = '' }) {
  return (
    <img
      src="/assets/brand/x3algo-mark.svg"
      alt={title || ''}
      className={clsx(SIZE_CLASSES[size] || SIZE_CLASSES.md, className)}
      aria-hidden={title ? undefined : true}
    />
  )
}

export default BrandMark
